/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
 * See LICENSE in the project root for license information.
 */

/* global Office */

Office.onReady(() => {
  // If needed, Office.js is ready to be called.
  // function onNewMessageComposeHandler(event: Office.AddinCommands.Event) {
  //   console.log("New message compose handler is called");
  //   Office.context.mailbox.item.body.setSelectedDataAsync("Hello World!");
  //   event.completed();
  // }
  //
  // Office.actions.associate("onNewMessageComposeHandler", onNewMessageComposeHandler);
});
